import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useMemo } from 'react'

import { Avatar } from '../Avatar'

import { Container } from './MenuUser.styles'

const maxLength = 26
export function MenuUser({ name, email, open }: { name: string; email: string; open: boolean }) {
  const theme = useTheme()

  const mail = useMemo(() => {
    if (email.length <= maxLength) return email
    const e = email.split('@')
    const prefix = e[0]
    const suffix = e[1]
    const shortPrefix = prefix.substring(0, 3) + '…' + prefix.substring(prefix.length - 3)
    const shorterEmail = shortPrefix + '@' + suffix
    if (shorterEmail.length <= maxLength) return shorterEmail
    const shortSuffix = suffix.substring(0, 3) + '…' + suffix.substring(suffix.lastIndexOf('.'))
    return shortPrefix + '@' + shortSuffix
  }, [email])

  return (
    <Container>
      <Box display="flex" flexDirection="row" width="100%" gap={theme.spacing.L}>
        <Avatar variant="large" />
        {open && (
          <Box display={'flex'} flexDirection="column" alignItems="flex-start">
            <Typography variant="body" color={theme.palette.text.inverse}>
              {name}
            </Typography>
            <Typography variant="caption" color={theme.palette.text.inverse}>
              {mail}
            </Typography>
          </Box>
        )}
      </Box>
      {open && <ChevronRightIcon sx={{ display: 'none', color: theme.palette.text.inverse }} />}
    </Container>
  )
}
